import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Database, CheckCircle } from 'lucide-react';
import { postManualInput } from './manualInputs/useManualInput';

const Box = styled.div`
  padding: 24px;
  color: rgba(255, 255, 255, 0.9);
`;

const Button = styled.button`
  margin-top: 12px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid rgba(76, 175, 80, 0.5);
  background: rgba(76, 175, 80, 0.15);
  color: #8f8;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export default function PremadeContextAdmin({ instanceId, locked = false, onApplied }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSeed = async () => {
    if (!instanceId || locked) return;
    setBusy(true);
    setError(null);
    try {
      const data = await postManualInput(instanceId, 'premade_context', 'apply', {});
      setResult(data.seed);
      onApplied?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box>
      <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>Valmiit vipupisteet ja linssit</h3>
      <p style={{ margin: 0, fontSize: 13, opacity: 0.75 }}>
        Kirjoittaa valmiin testidatan instanssiin (vipupisteet ja linssi-itemit). Uudelleenajo
        korvaa aiemmin kirjoitetut linssi-itemit.
      </p>
      <Button type="button" onClick={handleSeed} disabled={busy || locked}>
        <Database size={16} /> {busy ? 'Kirjoitetaan…' : 'Kirjoita valmis data'}
      </Button>
      {result && (
        <p style={{ marginTop: 12, fontSize: 13, color: '#8f8' }}>
          <CheckCircle size={14} style={{ verticalAlign: 'middle' }} />{' '}
          {result.pivot_set?.inserted ?? 0} vipupistettä, {result.lens_items?.inserted ?? 0} linssi-itemiä
        </p>
      )}
      {error && <p style={{ marginTop: 8, color: '#f88', fontSize: 13 }}>{error}</p>}
    </Box>
  );
}
